'use client'
declare global {
  interface Window {
    _hsp?: any[];
  }
}

const handleCookieConfig = () => {

  window._hsp = window._hsp || [];
  window._hsp.push(["showBanner"]);
};

const CookiesComponent = () => {
  return (
    <div className="container mx-auto pb-20">
      <div className="p-10  text-justify">
        <p className="text-lg font-bold">
          Introducción
        </p>
        <p className="text-lg">
          En Empresas MATCO (en adelante, &quot;nosotros&quot; o &quot;nuestro sitio web&quot;), utilizamos cookies y tecnologías similares para mejorar tu experiencia de navegación, analizar el uso de nuestro sitio y ofrecer contenido personalizado. Esta política explica qué son las cookies, cómo las utilizamos y cómo puedes gestionarlas.
        </p>
        <br />
        <p className="text-lg font-bold">
          ¿Qué son las cookies?
        </p>
        <p className="text-lg">
          Las cookies son pequeños archivos de texto que los sitios web envían al navegador y que se almacenan en tu dispositivo (ordenador, tableta o teléfono). Estas permiten que el sitio web recuerde información sobre tu visita, como tus preferencias o el contenido de tu carrito de compras.
        </p>

        <br />
        <p className="text-lg font-bold">
          Tipos de cookies que utilizamos
        </p>
        <ul className="list-disc list-inside px-10 pt-5">
          <li className="text-lg">
            <span className="text-black font-bold">Cookies esenciales: </span>
            Son necesarias para el funcionamiento del sitio web y no se pueden desactivar en nuestros sistemas. Por ejemplo, se usan para recordar tu inicio de sesión o proteger la seguridad del sitio.
          </li>
          <li className="text-lg">
            <span className="text-black font-bold">Cookies de funcionalidad: </span>
            Nos permiten ofrecerte funciones mejoradas y personalización, como recordar tus preferencias de idioma.
          </li>
          <li className="text-lg">
            <span className="text-black font-bold">Cookies analíticas: </span>
            Nos ayudan a entender cómo los usuarios interactúan con nuestro sitio web, recopilando información de forma anónima para mejorar la experiencia de usuario.
          </li>
          <li className="text-lg">
            <span className="text-black font-bold">Cookies publicitarias: </span>
            Estas cookies se utilizan para mostrar anuncios relevantes para ti y para medir la efectividad de nuestras campañas de marketing.
          </li>
        </ul>
        <br />
        <p className="text-lg font-bold">
          ¿Cómo usamos las cookies?
        </p>
        <ul className="list-disc list-inside px-10 pt-5">
          <li className="text-lg">
            Reconocerte cuando regresas a nuestro sitio web.
          </li>
          <li className="text-lg">
            Recordar tus preferencias y configuraciones.
          </li>
          <li className="text-lg">
            Analizar el tráfico del sitio para mejorarlo continuamente.
          </li>
          <li className="text-lg">
            Mostrarte publicidad personalizada en función de tus intereses.
          </li>
        </ul>
        <br />
        <p className="text-lg font-bold">
          Gestión de cookies
        </p>
        <p className="text-lg">
          Puedes gestionar las cookies desde la configuración de tu navegador. Ten en cuenta que deshabilitar ciertas cookies puede afectar el funcionamiento del sitio. A continuación, te proporcionamos enlaces a las guías de configuración de los navegadores más populares:
        </p>
        <ul className="list-disc list-inside px-10 pt-5">
          <li className="text-lg ">
            <a href="https://support.google.com/chrome/answer/95647" className="text-blue-500 hover:underline">
              Google Chrome
            </a>
          </li>
          <li className="text-lg">
            <a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" className="text-blue-500 hover:underline">
              Mozilla Firefox
            </a>
          </li>
          <li className="text-lg">
            <a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" className="text-blue-500 hover:underline">
              Safari
            </a>
          </li>
          <li className="text-lg">
            <a href="https://support.microsoft.com/es-es/microsoft-edge" className="text-blue-500 hover:underline">
              Microsoft Edge
            </a>
          </li>
        </ul>
        <br />
        <p className="text-lg">
          Asimismo, puedes rechazar o configurar el uso de Cookies, a través del siguiente botón:
        </p>
        <br />
        <div className="text-center">
          <button
            className="bg-yellow-500 text-black px-4 py-2 rounded font-bold"
            onClick={handleCookieConfig}
          >
            Configuración de Cookies
          </button>
        </div>

        <br />
        <p className="text-lg font-bold">
          Consentimiento
        </p>
        <p className="text-lg">
          Al continuar navegando en nuestro sitio web, aceptas el uso de cookies, salvo que las hayas desactivado en la configuración de tu navegador.
        </p>
        <br />
        <p className="text-lg font-bold">
          Cambios en esta política
        </p>
        <p className="text-lg">
          Podemos actualizar esta política de cookies en cualquier momento. Cualquier cambio será publicado en esta página y, cuando corresponda, te lo notificaremos.
        </p>
        <br />
        <p className="text-lg font-bold">
          Contacto
        </p>
        <p className="text-lg">
          Si tienes preguntas sobre nuestra política de cookies, puedes contactarnos a través de nuestro correo electrónico{' '}
          <a href="mailto:info@matco.com.mx" className="text-blue-500 hover:underline">
            info@matco.com.mx
          </a>.
        </p>
      </div>
    </div>
  );
};

export default CookiesComponent;
